import { render, staticRenderFns } from "./PoiPointField.vue?vue&type=template&id=19c1c4f3&scoped=true"
import script from "./PoiPointField.vue?vue&type=script&lang=ts"
export * from "./PoiPointField.vue?vue&type=script&lang=ts"
import style0 from "./PoiPointField.vue?vue&type=style&index=0&id=19c1c4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1c4f3",
  null
  
)

export default component.exports